import { CasinoNotificationMaintenanceNotification } from '@/schema';

const shouldDisplayNotification = (
  notification: CasinoNotificationMaintenanceNotification,
  context: WorkerContext,
) => {
  const { showForLoggedInUsers, showForLoggedOutUsers, content } = notification;
  return (
    content &&
    ((showForLoggedInUsers && context.token) ||
      (showForLoggedOutUsers && !context.token))
  );
};

export default shouldDisplayNotification;
